module.exports = __webpack_public_path__ + "img/stock6.3701b1ef.png";